import { api } from '../baseApi';
import { makeRequest } from '../makeRequest';
import type { BulkValidateRequest, BulkValidateResponse } from './dto';
import { bulkFilterAPIRoutes } from './route';

export async function validateBulkFilter(request: BulkValidateRequest): Promise<BulkValidateResponse> {
  return await makeRequest<BulkValidateResponse>(api.post(bulkFilterAPIRoutes.getBulkValidate(), request));
}
